import React from 'react';

export default function TimeReviewWidget(props) {
  return <span>{props.value}</span>;
}
